<template>
  <v-card elevation="3" outlined class="mb-4">
    <v-card-title class="mycard-title-1 fsize-4 fcolor-1 bg-color-3">
      <v-icon class="mr-2" color="white">mdi-clipboard-text</v-icon>
      Nomination Summary
    </v-card-title>
    <v-card-text>
      <v-container>
        <v-row>
          <v-col cols="12" md="4">
            <v-card outlined class="text-center pa-4">
              <v-avatar size="80" class="mb-3">
                <v-img
                  :src="memberInfo.MemberImagePath"
                  :alt="memberInfo.MemberName"
                >
                  <template v-slot:placeholder>
                    <v-icon size="40" color="grey lighten-2"
                      >mdi-account</v-icon
                    >
                  </template>
                </v-img>
              </v-avatar>
              <div class="text-h6 font-weight-bold mb-1">
                {{ memberInfo.MemberName }}
              </div>
              <div class="text-subtitle-2 text--secondary mb-2">
                {{ memberInfo.Profession }}
              </div>
              <v-chip small color="primary" dark>{{
                memberInfo.MembershipId
              }}</v-chip>
            </v-card>
          </v-col>

          <v-col cols="12" md="4">
            <v-card outlined class="text-center pa-4">
              <v-icon size="60" color="#0097d7" class="mb-3"
                >mdi-office-building</v-icon
              >
              <div class="text-h6 font-weight-bold mb-1">
                {{ lomInfo.LomName }}
              </div>
              <div class="text-subtitle-2 text--secondary mb-2">
                {{ lomInfo.ZoneName }}
              </div>
              <v-chip small :color="lomInfo.LomStatusColor" dark>
                {{ lomInfo.LomStatusTxt }}
              </v-chip>
            </v-card>
          </v-col>

          <v-col cols="12" md="4">
            <v-card
              outlined
              class="text-center pa-4"
              v-if="paymentInfo && Object.keys(paymentInfo).length > 0"
            >
              <v-icon size="60" color="#56BDA3" class="mb-3"
                >mdi-credit-card</v-icon
              >
              <div class="text-h6 font-weight-bold mb-1">
                {{ paymentInfo.PaymentAmount }}
              </div>
              <div class="text-subtitle-2 text--secondary mb-2">
                {{ paymentInfo.PaymentDate }}
              </div>
              <v-chip small :color="paymentInfo.PaymentColor" dark>
                {{ paymentInfo.PaymentRzrpayId }}
              </v-chip>
            </v-card>
            <v-card outlined class="text-center pa-4" v-else>
              <v-icon size="60" color="grey" class="mb-3"
                >mdi-credit-card-off</v-icon
              >
              <div class="text-subtitle-1 text--secondary">Payment Pending</div>
            </v-card>
          </v-col>
        </v-row>

        <!-- Quick Stats -->
        <v-row class="mt-4" v-if="QuickStatsFlag">
          <v-col cols="12">
            <v-divider class="mb-4"></v-divider>
            <div class="subsection-title mb-3">
              <v-icon small class="mr-1">mdi-chart-box</v-icon>
              Quick Statistics
            </div>
          </v-col>
        </v-row>

        <v-row v-if="QuickStatsFlag">
          <v-col cols="6" sm="3">
            <div class="stat-card">
              <div class="stat-number">{{ lomInfo.VotingCount || 0 }}</div>
              <div class="stat-label">Voting Count</div>
            </div>
          </v-col>
          <v-col cols="6" sm="3">
            <div class="stat-card">
              <div class="stat-number">{{ officesHeldData.length }}</div>
              <div class="stat-label">Aadhaar Verification</div>
            </div>
          </v-col>
          <v-col cols="6" sm="3">
            <div class="stat-card">
              <div class="stat-number">{{ lomGrowthData.length }}</div>
              <div class="stat-label">Continuous Subscription</div>
            </div>
          </v-col>
          <v-col cols="6" sm="3">
            <div class="stat-card">
              <div class="stat-number">{{ latestGrowthCount }}</div>
              <div class="stat-label">Nomination Qualification</div>
            </div>
          </v-col>
        </v-row>

        <!-- Action Items -->
        <v-row class="mt-4" v-if="showActions">
          <v-col cols="12">
            <v-divider class="mb-4"></v-divider>
            <div class="subsection-title mb-3">
              <v-icon small class="mr-1">mdi-format-list-checks</v-icon>
              Action Items
            </div>
            <v-list dense>
              <v-list-item
                v-for="action in actionItems"
                :key="action.id"
                class="px-0"
              >
                <v-list-item-icon>
                  <v-icon :color="action.completed ? 'success' : 'warning'">
                    {{
                      action.completed
                        ? "mdi-check-circle"
                        : "mdi-clock-outline"
                    }}
                  </v-icon>
                </v-list-item-icon>
                <v-list-item-content>
                  <v-list-item-title>{{ action.title }}</v-list-item-title>
                  <v-list-item-subtitle>{{
                    action.description
                  }}</v-list-item-subtitle>
                </v-list-item-content>
                <v-list-item-action v-if="!action.completed">
                  <v-btn
                    small
                    outlined
                    color="primary"
                    @click="$emit('action-click', action)"
                  >
                    Complete
                  </v-btn>
                </v-list-item-action>
              </v-list-item>
            </v-list>
          </v-col>
        </v-row>
      </v-container>
    </v-card-text>
  </v-card>
</template>

<script>
export default {
  name: "NominationSummaryCard",
  props: {
    memberInfo: {
      type: Object,
      default: () => ({}),
    },
    lomInfo: {
      type: Object,
      default: () => ({}),
    },
    officesHeldData: {
      type: Array,
      default: () => [],
    },
    lomGrowthData: {
      type: Array,
      default: () => [],
    },
    paymentInfo: {
      type: Object,
      default: () => ({}),
    },
    showActions: {
      type: Boolean,
      default: false,
    },
    actionItems: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      QuickStatsFlag:false,
    };
  },
  computed: {
    latestGrowthCount() {
      if (!this.lomGrowthData || this.lomGrowthData.length === 0) return 0;
      const latest = this.lomGrowthData.sort(
        (a, b) => b.YearName - a.YearName
      )[0];
      return latest?.Count || 0;
    },
  },
  methods: {
    getStatusColor(status) {
      switch (status?.toLowerCase()) {
        case "active":
          return "success";
        case "inactive":
          return "error";
        case "suspended":
          return "warning";
        default:
          return "grey";
      }
    },
    getPaymentStatusColor(status) {
      switch (status?.toLowerCase()) {
        case "completed":
        case "success":
          return "success";
        case "failed":
        case "error":
          return "error";
        case "pending":
          return "warning";
        default:
          return "grey";
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.stat-card {
  text-align: center;
  padding: 16px;
  border-radius: 8px;
  background: #f5f5f5;

  .stat-number {
    font-size: 24px;
    font-weight: 700;
    color: #1976d2;
    line-height: 1.2;
  }

  .stat-label {
    font-size: 12px;
    font-weight: 500;
    color: rgba(0, 0, 0, 0.6);
    text-transform: uppercase;
    letter-spacing: 0.5px;
    margin-top: 4px;
  }
}

.subsection-title {
  font-size: 16px;
  font-weight: 600;
  color: #edbe38;
  display: flex;
  align-items: center;
  margin-bottom: 8px;
}

/* Avatar and Image Styles */
.v-avatar .v-image {
  border-radius: 50%;
}

.v-avatar .v-image .v-image__error,
.v-avatar .v-image .v-image__placeholder {
  background-color: #f5f5f5;
  border-radius: 50%;
}

.mycard-title-1 {
  font-family: sans-serif;
  padding: 16px;
  text-align: left;
  word-break: break-word;
  line-height: normal;
}

.fsize-4 {
  font-size: 18px !important;
}

.fcolor-1 {
  color: #fff !important;
}

.bg-color-3 {
  background-color: #edbe38;
}
</style>
